import { styled } from '../../../theme/styled';

export const TabsRoot = styled('div', {
  name: 'Tabs',
  slot: 'Root',
})(() => ({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));
